import React from 'react';
import "./base.css";

import { Link } from 'react-router-dom';  


const Header = () => {
    return (
        <div className="container">
            <header className="header">
                <nav className="navbar">
                    <div className="logo">Aad van Dam</div>
                    <div className="nav-links">
                        <Link to="/">Home</Link>
                        <Link to="/contact">Contact</Link>
                    </div>
                </nav>
            </header>
        </div>
    );
};

export default Header;
